import { computed, inject, onMounted, ref, watch } from 'vue';
import { useI18N } from '@/plugins/i18n';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { useVuelidate } from '@vuelidate/core';
import { PropType } from 'vue';

export default {
  mixins: [validationMixin],

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    action: {
      type: Function as PropType<(name: string, surname: string, email: string, sendWelcomeEmail: boolean) => void>,
      required: true
    }
  },

  validations: {
    nameRef: { required },
    surnameRef: { required },
    emailRef: {
      required,
      email,
      minLength: minLength(5),
      maxLength: maxLength(254)
    }
  },

  setup(props) {
    const i18n = useI18N();
    const nameRef = ref('');
    const surnameRef = ref('');
    const emailRef = ref('');
    const v$ = useVuelidate();
    const sendWelcomeEmail = ref(false);

    const handleClose = () => {
      props.onClose();
      nameRef.value = '';
      surnameRef.value = '';
      emailRef.value = '';
      v$.value.$reset();
    };

    const handleAdd = () => {
      v$.value.$touch();
      if (!v$.value.$invalid) {
        props.action(nameRef.value, surnameRef.value, emailRef.value, sendWelcomeEmail.value);
        nameRef.value = '';
        surnameRef.value = '';
        emailRef.value = '';
        v$.value.$reset();
        sendWelcomeEmail.value = false;
      }
    };

    return {
      nameRef,
      surnameRef,
      emailRef,
      handleClose,
      handleAdd,
      v$,
      sendWelcomeEmail
    };
  }
};
